//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var map
var markersData=[]
import uniPopup from "@/components/uni-popup/uni-popup.vue"

var amapFile = require('@/common/library/amap-wx.js');//如：..­/..­/libs/amap-wx.js

export default {
  data () {
    return {
      map: '',
      AMap: '',
      lngLat: {
        lng: '',
        lat: '',
        show: false
      },
	  markers: [],
	  poisdatas: [{}, {}, {}],
	  latitude: '',
	  longitude: '',
      height: 667,
      active: 0,
	  selectId:0,
      show: false,
      detail: {
        distance: 0
      },
      list: [{
        img: require('@/static/service/scenicSpot.png'),
        imgActive: require('@/static/service/scenicSpot_active.png'),
        name: '风景'
      },
      {
        img: require('@/static/service/hotel.png'),
        imgActive: require('@/static/service/hotel_active.png'),
        name: '住宿'
      },
      {
        img: require('@/static/service/cate.png'),
        imgActive: require('@/static/service/cate_active.png'),
        name: '餐饮'
      },
      {
        img: require('@/static/service/p.png'),
        imgActive: require('@/static/service/p_active.png'),
        name: '停车'
      },
      {
        img: require('@/static/service/wc.png'),
        imgActive: require('@/static/service/wc_active.png'),
        name: '厕所'
      }
      ],
      markersResource: [],
	  selectMarket:{},
	  window:''
    }
  },
  components: {
	  uniPopup
  },
  onReady() {





  	this.mpInit()

  },
  onLoad() {
  	var res = uni.getSystemInfoSync();
  	this.height = res.windowHeight;
  },
  methods: {
	  async mpInit(){
		var that = this;
		var myAmapFun = new amapFile.AMapWX({key:'6297fab76bb6d15d0fd82fba01eac987'});		
		myAmapFun.getPoiAround({
			iconPathSelected: '../../static/service/loc.png', //如：..­/..­/img/marker_checked.png
			iconPath: '../../static/service/loc.png', //如：..­/..­/img/marker.png
			success: function(data){
				that.showResouce()
		},
		fail: function(info){
			wx.showModal({title:info.errMsg})
		}
		})
	  },
	  async showResouce(){
		  let resource=await this.getAround()
		let markers_new=[]
			resource.data.pois.forEach(function(item,index){
				let _location=item.location.split(',')
				markers_new.push({
				        id: index,              //marker 序号
				        width: 37,        //marker 宽度
				        height: 37,      //marker 高度
				        iconPath: '../../static/service/loc.png',  //marker 图标路径
				        latitude: _location[1],  //marker  纬度
				        longitude: _location[0], //marker 经度
						name:item.name,
						address:item.address
				})
			})
		 markersData=markers_new
		this.markers=markersData
		this.latitude=this.$store.state.mapCenter[1]
		this.longitude=this.$store.state.mapCenter[0]  
	  },
		makertap(e){
			this.selectId=e.markerId
			this.detail.name=this.markers[e.markerId].name
			this.detail.address=this.markers[e.markerId].address
			this.show=true
		},
    init () {
      let _this = this
      // AMap = window.AMap
      map = new window.AMap.Map(('container'), {
        resizeEnable: true,
        zoom: 14
      })
      this.map = map	  
	  this.map.setCenter(this.$store.state.mapCenter)
      map.plugin('AMap.Geolocation', function () {
       var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          buttonPosition: 'LT'
        })
        map.addControl(geolocation)
        geolocation.getCurrentPosition()
        window.AMap.event.addListener(geolocation, 'complete', _this.onComplete) // 返回定位信息
        window.AMap.event.addListener(geolocation, 'error', _this.onError) // 返回定位出错信息
      })
    },
    onComplete (data) {
      let str = ['定位成功']
      str.push('经度：' + data.position.getLng())
      str.push('纬度：' + data.position.getLat())

      this.lngLat.lng = data.position.getLng()
      this.lngLat.lat = data.position.getLat()
      // alert(_this.lngLat.lng, _this.lngLat.lat)
      if (data.accuracy) {
        str.push('精度：' + data.accuracy + ' 米')
      } // 如为IP精确定位结果则没有精度信息
      str.push('是否经过偏移：' + (data.isConverted ? '是' : '否'))
    },
    // 解析定位错误信息
    onError (data) {
      uni.showToast({
      	title:'定位失败',
		icon:'none'
      })
    },
    handleClick (index) {
      this.active = index




	  this.showResouce()

    },
    getTypes (points, marker, img) {
	  let _this=this
	  AMapUI.loadUI(['overlay/SimpleInfoWindow'], function(SimpleInfoWindow) {
	  		points.forEach(t=>{
	  			let loc=t.location.split(',')
	  			let g={
	  				lat:loc[1],
	  				lng:loc[0],
	  				P:loc[1],
	  				Q:loc[0],
					name:t.name,
					address:t.address
	  			}
	  			var marker = new AMap.Marker({
	  			    map: map,
	  			    zIndex: 9999999,
	  			    position: g
	  			});
	  			_this.markersResource.push(marker)
	  			var infoWindow = new SimpleInfoWindow({
	  			    //模板, underscore
	  			    infoTitle: '',
	  			    infoBody: '<div class="contain">' +
	  			        //<%= 原值插入 ..
	  					'<div class="left"><p class="title"><%- title %></p>'+
	  			        //<%- html编码后插入
	  			        '<%- body %></div><div class="right"><div class="text">查看路线</div></div>' +
	  			        '</div>',
	  			    //模板数据
	  			    infoTplData: {
	  			        title: t.name,
	  			        body: `${t.address}`
	  			    },
	  							
	  			    //基点指向marker的头部位置
	  			    offset: new AMap.Pixel(0, -31)
	  			});
	  			function openInfoWin() {								
	  			    infoWindow.open(map, marker.getPosition());
	  			}
	  			infoWindow.get$InfoBody().on('click', '.right', function(event) {
	  				//阻止冒泡
	  				event.stopPropagation();
					_this.showPosition()
	  				// map.remove(_this.m)
	  			});			
	  			//marker 点击时打开
	  			AMap.event.addListener(marker, 'click', function() {					
					_this.window=infoWindow
					_this.selectMarket=marker
					_this.detail=marker.getPosition()
	  			    openInfoWin();
	  			});
	  		})
	      })
    },
	getAround(){
		return this.$ajax({
			method: 'post',
			url: '/weChat/cms/around/getAroundInfo',
			data: {
			  keywords: '', // 关键字
			  offset: 100, // 偏移量
			  page: 1, // 页数
			  types: this.list[this.active].name, // 类型
			  city: '360105', // 城市 360105//湾里 360100南昌
			  children: '', // 子类
			  extensions: '' // 扩展
			}
		})
	},
    async getResourcePoint () {
		uni.showLoading({
		title:'加载中...'
		})
		if(this.window){
		this.window.close(map,this.selectMarket.getPosition())
		}
		this.resourceShow = true
		let data=await this.getAround()
		this.map.remove(this.markersResource)
		this.markersResource = []
		this.getTypes(data.data.pois, this.markersResource, this.imgResource)
		this.map.setCenter(this.$store.state.mapCenter)
		this.map.setZoom(11)
		uni.hideLoading()
    },
    showPosition () {












	    wx.openLocation({
	     latitude:parseFloat(this.markers[this.selectId].latitude),
	     longitude: parseFloat(this.markers[this.selectId].longitude),
	     name:this.markers[this.selectId].name,
		 address: this.markers[this.selectId].address,
	     scale: 16
	    })

    }
  }
}

